<app-launch-field-container 
[basespaceFormControl]="formControl"
>
    <rad-textarea
            class="rad-theme--light"
            [formControl]="formControl"
            [attr.id]="formControl.id"
            [attr.maxlength]="formControl.maxLength"
            [attr.rows]="formControl.getRowsFromPixelHeight()"
            [attr.required]="formControl.required"
            [attr.requiredMessage]="formControl.requiredMessage"
            [attr.error]="formControl.errors?.required || formControl.basespaceErrors.length > 0"
            (focus)="onFocus()"
            (blur)="onBlur()"
        ></rad-textarea>
</app-launch-field-container>